module.exports = __webpack_public_path__ + "static/img/no-collection.fd6a6472.png";